import React, { FC } from "react";

const LoadingBlock: FC = () => <img src="/images/loading.svg" style={{ height: "100%", maxHeight: "70vh", width: "100%" }} alt="loading" />;

export default LoadingBlock;
